import React from 'react'

import { Box, Typography, Divider, makeStyles } from '@material-ui/core'

import useCustomerSummary from './useCustomerSummary'

import ModifyButton from '~/ui/components/ModifyButton/ModifyButton'

const useStyles = makeStyles({
  capitalize: {
    textTransform: 'capitalize',
  },
})

export default function CustomerSummary() {
  const {
    docId,
    docType,
    fullName,
    nationality,
    birthdate,
    contactPhone,
    segment,
    isCompany,
    cif,
    companyName,
    gender,
  } = useCustomerSummary()

  const { capitalize } = useStyles()

  return (
    <Box data-hook="customer-summary">
      <Box display="flex" flexDirection="row" alignItems="baseline" mt={5} mb={4}>
        <Typography variant="body2">Tipo de cliente: </Typography>
        <Box ml={1}>
          <Typography variant="subtitle2" data-hook="segment">
            {segment}
          </Typography>
        </Box>
      </Box>
      {isCompany && (
        <>
          <Divider className="dotted" />
          <Box mt={6}>
            <Typography variant="subtitle1">DATOS DEL ADMINISTRADOR</Typography>
          </Box>
        </>
      )}
      <Box display="flex" flexDirection="row" alignItems="baseline" mt={5} mb={4}>
        <Box display="flex" flexDirection="row" alignItems="baseline">
          <Typography variant="body2" data-hook="docType">
            {docType}:
          </Typography>
          <Box ml={1}>
            <Typography variant="subtitle2" data-hook="docId">
              {docId}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="baseline" ml={8}>
          <Typography variant="body2">Nacionalidad: </Typography>
          <Box ml={1}>
            <Typography variant="subtitle2" data-hook="nationality">
              {nationality}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="baseline" ml={8}>
          <Typography variant="body2">Nombre y Apellidos: </Typography>
          <Box ml={1}>
            <Typography variant="subtitle2" data-hook="fullName" className={capitalize}>
              {fullName}
            </Typography>
          </Box>
        </Box>
        {!isCompany && gender && (
          <Box display="flex" flexDirection="row" alignItems="baseline" ml={8}>
            <Typography variant="body2">Género: </Typography>
            <Box ml={1}>
              <Typography variant="subtitle2" data-hook="gender">
                {gender}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
      <Box display="flex" flexDirection="row" alignItems="baseline" mt={5} mb={4}>
        {!isCompany && (
          <Box display="flex" flexDirection="row" alignItems="baseline" mr={8}>
            <Typography variant="body2">Fecha de nacimiento: </Typography>
            <Box ml={1}>
              <Typography variant="subtitle2" data-hook="birthdate">
                {birthdate}
              </Typography>
            </Box>
          </Box>
        )}
        <Box display="flex" flexDirection="row" alignItems="baseline">
          <Typography variant="body2">Teléfono de contacto: </Typography>
          <Box ml={1}>
            <Typography variant="subtitle2" data-hook="contactPhone">
              {contactPhone}
            </Typography>
          </Box>
        </Box>
      </Box>
      {isCompany && (
        <>
          <Divider className="dotted" />
          <Box mt={6}>
            <Typography variant="subtitle1">DATOS DE LA EMPRESA</Typography>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="baseline" mt={5} mb={4}>
            <Box display="flex" flexDirection="row" alignItems="baseline">
              <Typography variant="body2">Nombre de la empresa: </Typography>
              <Box ml={1}>
                <Typography variant="subtitle2" data-hook="companyName">
                  {companyName}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" alignItems="baseline" ml={8}>
              <Typography variant="body2">CIF: </Typography>
              <Box ml={1}>
                <Typography variant="subtitle2" data-hook="cif">
                  {cif}
                </Typography>
              </Box>
            </Box>
          </Box>
        </>
      )}
      <ModifyButton text="Modificar datos del Titular" />
    </Box>
  )
}
